import $api from "http/index";

const B = "library/";

export const listBooks = (params) => $api.get(`${B}books/`, { params });
export const getBook = (id) => $api.get(`${B}books/${id}/`);
export const createBook = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (Array.isArray(v)) v.forEach((x) => fd.append(k, x));
    else fd.append(k, v);
  });
  return $api.post(`${B}books/`, fd);
};
export const updateBook = (id, data) => $api.patch(`${B}books/${id}/`, data);
export const deleteBook = (id) => $api.delete(`${B}books/${id}/`);
export const booksBySubject = (subject) => $api.get(`${B}books/by-subject/`, { params: { subject } });

export const listCategories = () => $api.get(`${B}categories/`);
export const createCategory = (data) => $api.post(`${B}categories/`, data);

export const listCheckouts = (params) => $api.get(`${B}checkouts/`, { params });
export const myCheckouts = () => $api.get(`${B}checkouts/my/`);
export const issueBook = (data) => $api.post(`${B}checkouts/issue/`, data);
export const returnBook = (id, data) => $api.post(`${B}checkouts/${id}/return/`, data || {});
export const markOverdue = () => $api.post(`${B}checkouts/mark-overdue/`);

export const listReservations = (params) => $api.get(`${B}reservations/`, { params });
export const createReservation = (data) => $api.post(`${B}reservations/`, data);

export const KIND_LABELS = {
  textbook: "Учебник", manual: "Учебное пособие", monograph: "Монография",
  journal: "Журнал", collection: "Сборник", digital: "Электронный",
  dissertation: "Диссертация", other: "Другое",
};
